import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  DropPaycheck,
  DropPaycheckIcon,
  FormActions,
  FileName,
} from "./styled";
import DashboardCardWrapper from "components/Dashboard/Cards/Wrapper";
import DashboardActions from "components/Dashboard/Actions";
import DashboardFormsCore from "../Core";
import UploadFile from "components/Form/UploadFile";
import { CalendarInput } from "components/Form/Calendar";
import { toast } from "react-toastify";
import { CoreContext } from "context/CoreContext";
import { uploadVacation } from "services/vacation-upload";
import { sendNotificationMessage } from "services/notifications";
import { ReadOne } from "services/employee";

export default function DashboardFormsVacation() {
  const history = useHistory();
  const { currentCompany, user } = useContext(CoreContext); // Contexto da empresa atual
  const { id } = useParams();
  const refForm = useRef();
  const [saving, setSaving] = useState(false);

  const actions = [
    { title: "Cancelar", outline: true, action: () => history.goBack() },
    { title: "Salvar", action: () => save(), loadable: true },
  ];

  const [formItems, setFormItems] = useState([]);
  const [selectedInitDate, setSelectedInitDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        // Constrói dinamicamente os itens do formulário
        const updatedFormItems = [
          {
            ref: "initialDate",
            placeholder: "Data Inicial",
            custom: (
              <div>
                <label
                  htmlFor="initialDate"
                  style={{
                    display: "block",
                    marginBottom: "5px",
                    fontSize: "13px",
                  }}
                >
                  Inicio Período Aquisitivo
                </label>
                <CalendarInput
                  id="initialDate"
                  placeholder="Data Inicial"
                  secondary
                  disabled={false}
                  value={selectedInitDate} // Binds to the selectedInitDate state
                  onChange={(formattedDate) => {
                    setSelectedInitDate(formattedDate); // Updates selectedInitDate directly
                  }}
                />
              </div>
            ),
            quarter: true,
          },
          {
            ref: "endDate",
            placeholder: "Data Final",
            custom: (
              <div>
                <label
                  htmlFor="endDate"
                  style={{
                    display: "block",
                    marginBottom: "5px",
                    fontSize: "13px",
                  }}
                >
                  Final Período Aquisitivo
                </label>
                <CalendarInput
                  id="endDate"
                  placeholder="Final Período Aquisitivo"
                  secondary
                  disabled={false}
                  value={selectedEndDate} // Binds to the selectedEndDate state
                  onChange={(formattedDate) => {
                    setSelectedEndDate(formattedDate); // Updates selectedEndDate directly
                  }}
                />
              </div>
            ),
            quarter: true,
          },
          {
            placeholder: "Arquivo",
            ref: "file",
            custom: (
              <div>
                <label
                  htmlFor="file"
                  style={{
                    display: "block",
                    marginBottom: "5px",
                    fontSize: "13px",
                  }}
                >
                  Arquivo de Férias
                </label>
                {selectedFile?.name ? (
                  <DropPaycheck onClick={() => setSelectedFile(null)}>
                    <FileName>{selectedFile?.name}</FileName>
                    <DropPaycheckIcon close />
                  </DropPaycheck>
                ) : (
                  <UploadFile forwardRepo onChange={(e) => setSelectedFile(e)}>
                    <DropPaycheck>
                      <DropPaycheckIcon /> Adicionar arquivo
                    </DropPaycheck>
                  </UploadFile>
                )}
              </div>
            ),
            half: true,
          },
        ];

        // Atualiza os itens do formulário com a lista definida
        setFormItems(updatedFormItems);
      } catch (error) {
        console.error("Erro ao buscar funcionários:", error);
      }
    };

    if (currentCompany?.id) {
      fetchEmployees();
    }
  }, [selectedInitDate, selectedEndDate, selectedFile, currentCompany]);

  const save = async () => {
    // Validação de campos obrigatórios
    if (!selectedInitDate || !selectedEndDate || !selectedFile) {
      toast.error("Por favor, preencha todos os campos obrigatórios.");
      return;
    }

    const parseDate = (dateString) => {
      const [day, month, year] = dateString.split("/").map(Number);
      return new Date(year, month - 1, day); // Mês começa em 0 (Janeiro)
    };

    const initDate = parseDate(selectedInitDate);
    const endDate = parseDate(selectedEndDate);

    if (initDate > endDate) {
      console.error("DataInicial:", initDate);
      console.error("DataFinal:", endDate);
      console.error("A data inicial não pode ser maior que a data final.");
      toast.error("A data inicial não pode ser maior que a data final.");
      return;
    }

    try {
      setSaving(true); // Inicia o estado de salvamento

      // Payload para salvar dados
      const payload = {
        type: "vacation",
        payload: {
          initialDate: selectedInitDate,
          endDate: selectedEndDate,
          employeeId: id,
          user: user.email,
          companyId: currentCompany?.id,
        },
      };

      // Upload dos dados
      const result = await uploadVacation(selectedFile, payload);

      if (result.success) {
        toast.success("Dados salvos com sucesso!");

        // busca os dados do funcionário
        const employee = await ReadOne(id);

        // Configuração de notificação
        const messageRequest = {
          TipoApp: 3, // Exemplo: Holerite
          Title: "Recibo de Férias",
          Body: `O seu Recibo de Férias já está disponível.`,
          ImgUrl: null,
          ImgBase64: null, // Caso não tenha base64, deixe como null
          ReenviarMarcacao: false, // Exemplo: habilitar o reenvio
          TokenList: [employee.data.attributes.token], // Lista de tokens
        };

        const result = await sendNotificationMessage(messageRequest);
        console.log("🚀 ~ Notificação enviada com sucesso:", result);

        if (result.error) {
          console.error("Erro ao enviar notificação:", result.message);
          toast.error(result.message || "Erro ao enviar a notificação");
        }

        // Paginação dos registros
        const totalRecords = result.data; // Total de registros retornado pela API
        const recordsPerPage = 10; // Número de registros por página
        const lastPage = Math.ceil(totalRecords / recordsPerPage); // Cálculo da última página

        history.push(`/dashboard/vacantion?page=${lastPage}`); // Navegação para última página
      } else {
        const errorMessage = await result.text(); // Mensagem de erro do backend
        console.error("Erro ao salvar os dados:", errorMessage);
        throw new Error(errorMessage);
      }
    } catch (error) {
      console.error("Erro ao salvar:", error);
      toast.error("Erro ao salvar. Tente novamente mais tarde.");
    } finally {
      setSaving(false); // Finaliza o estado de salvamento
    }
  };

  return (
    <>
      <DashboardCardWrapper backable title={"Novo Arquivo de Férias"} white>
        <DashboardFormsCore
          disabled={!!id}
          formItems={formItems}
          ref={refForm}
        />
        <FormActions>
          <DashboardActions actions={actions} loading={saving} />
        </FormActions>
      </DashboardCardWrapper>
    </>
  );
}
